import React from "react";
import { Center, Text } from "@chakra-ui/react";
import { Loader } from "../../Components";

const Loading: React.FC = () => (
  <Center flexDirection="column" w="100vw" h="100vh">
    <Loader />
    <Text textStyle="body1" mt={4}>
      Loading...
    </Text>
  </Center>
);

export default Loading;
